// extracted by mini-css-extract-plugin
export default {"hoverContent":"Favorites-module__hoverContent--sIoBN","menuButton":"Favorites-module__menuButton--lqp8Q","animatedBackground":"Favorites-module__animatedBackground--_GGUj"};